"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const layoutSvg_1 = __importDefault(require("./layoutSvg"));
const svgTemplates_1 = require("./svgTemplates");
const render_1 = __importDefault(require("./render"));
const styleSvg_1 = __importDefault(require("./styleSvg"));
const labelSvg_1 = __importDefault(require("./labelSvg"));
const alignmentSvg_1 = __importDefault(require("./alignmentSvg"));
const axisSvg_1 = __importDefault(require("./axisSvg"));
const highlightSvg_1 = __importDefault(require("./highlightSvg"));
const scaleSvg_1 = __importDefault(require("./scaleSvg"));
const geneSvg_1 = __importDefault(require("./geneSvg"));
function svgCreater() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const options = this;
        options.svg_template = [];
        options.use(styleSvg_1.default);
        options.use(layoutSvg_1.default);
        options.use(labelSvg_1.default);
        options.use(alignmentSvg_1.default);
        options.use(highlightSvg_1.default);
        yield options.use(geneSvg_1.default);
        options.use(axisSvg_1.default);
        options.use(scaleSvg_1.default);
        (_a = options.svg_template) === null || _a === void 0 ? void 0 : _a.unshift(svgTemplates_1.SVG_START);
        (_b = options.svg_template) === null || _b === void 0 ? void 0 : _b.push(svgTemplates_1.SVG_END);
        options.svg = (0, render_1.default)(options.svg_template, options);
    });
}
exports.default = svgCreater;
